import { service } from '@/utils/net'

export interface CheckInDay {
  day: number
  status: number
  isToday: number
  rewardIcon: string
  /** 0 非法，1 资产（数量），2 道具（天数） */
  rewardType: number
  rewardAmount: number
  rewardName: string
}

export interface CheckInInfo {
  eligible: number
  endReason: number
  timezone: string
  serverTime: number
  windowEndTime: number
  streak: number
  todayChecked: number
  days: CheckInDay[]
}

export interface CheckInSignResult extends CheckInInfo {
  result: number
  rewardStatus: number
}

export function getInfo() {
  return service<Response<CheckInInfo>>({
    method: 'GET',
    url: '/doniaLiveCheckIn/getInfo',
    silent: true
  }).then((res) => res?.data)
}

export function sign() {
  return service<Response<CheckInSignResult>>({
    method: 'POST',
    url: '/doniaLiveCheckIn/sign',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: new URLSearchParams(),
    silent: true
  }).then((res) => res?.data)
}

export function popupAck() {
  return service<Response<null>>({
    method: 'POST',
    url: '/doniaLiveCheckIn/popupAck',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: new URLSearchParams(),
    silent: true
  }).then((res) => res?.data)
}
